import { useEffect } from 'react';
import { Provider } from 'jotai';

import { setAuthHeader } from '~/api/clients';
import { normalizeTokenType } from '~/api/utils';

import { authState, authStore } from './state';

export const AuthStoreProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // Set the authentication header for both API clients on initial render
  useEffect(() => {
    const auth = authState.get();

    if (auth.accessToken && auth.tokenType) {
      setAuthHeader(
        'Authorization',
        `${normalizeTokenType(auth.tokenType)} ${auth.accessToken}`,
      );
    }
  }, []);

  return <Provider store={authStore}>{children}</Provider>;
};
